module.exports = __webpack_public_path__ + "media/images/acad_council/sam_hellman-2898b94ebe7971269a0e4d2e2f32e5ee.jpg";